/* ---------------------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------------------------*/

/*
A decimal separator is a symbol used to separate the integer part from the fractional part of a number written in decimal form (e.g., "." or "," in 12.45 or 12,45)
decimalSeparator can be used to identify the type of decimal separator based on browser language
*/

export var decimalSeparator = getBrowserLanguageBasedDecimalSeparator();

function getBrowserLanguageBasedDecimalSeparator() {
  let decimalSeperator = '.';
  const nonEuropeanNumberFormat = '120.94';
  const EuropeanNumberFormat = '120,94';
  if (Number(nonEuropeanNumberFormat).toLocaleString() === EuropeanNumberFormat) {
    decimalSeperator = ',';
  } else if (Number(nonEuropeanNumberFormat).toLocaleString() === nonEuropeanNumberFormat) {
    decimalSeperator = '.';
  }
  return decimalSeperator;
}
